import React from 'react';
import { useNavigate } from 'react-router-dom';

import useAsync from '../../../hooks/useAsync';
import { getIntegrations } from '../../../api/company';
import { classNames } from '../../../components/helpers/functions';
import { DeviceTabletIcon } from '@heroicons/react/24/outline';
import useModal from '../../../hooks/useModal';
const Integrations = () => {
	const navigate = useNavigate();

	const { value: loadedIntegrations } = useAsync(getIntegrations);
	const { setOpen: onOpenTabletView } = useModal('tabletView');

	console.log('loadedIntegrations: ', loadedIntegrations);

	const integrations = [...(loadedIntegrations ? loadedIntegrations : [])];

	return (
		<>
			<h2 className="text-base font-semibold leading-6 text-gray-900">
				Integrations
			</h2>
			<p className="mt-1 text-sm text-gray-500 mb-6">
				Integrations allow the platform to connect to an external data source
				which can then be used in multiple locations within the platform.
				Contact us to add an integration not listed below
			</p>

			<div>
				<ul
					role="list"
					className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3"
				>
					{integrations?.map((integration) => {
						const isActive = integration?.organizations?.length;

						return (
							<li
								key={integration.id}
								className="col-span-1 flex flex-col divide-y divide-gray-200 rounded-lg bg-white text-center shadow hover:shadow-lg cursor-pointer"
								onClick={() =>
									navigate(`/settings/integrations/${integration.id}`)
								}
							>
								<div className="flex flex-1 flex-col p-8">
									<img
										className="mx-auto h-32 w-32 flex-shrink-0 rounded-full"
										src={integration.logoUrl}
										alt=""
									/>
									<h3 className="mt-6 text-sm font-medium text-gray-900">
										{integration.name}
									</h3>
									<dl className="mt-1 flex flex-grow flex-col justify-between">
										<dt className="sr-only">Role</dt>
										<dd className="mt-3">
											<span
												className={classNames(
													'inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ring-1 ring-inset',
													isActive
														? ' bg-green-50 text-green-700 ring-green-600/20'
														: ' bg-gray-50 text-gray-700 ring-gray-600/20'
												)}
											>
												{isActive ? 'Active' : 'Inactive'}
											</span>
										</dd>
									</dl>
								</div>
							</li>
						);
					})}

					<li
						className="col-span-1 flex flex-col divide-y divide-gray-200 rounded-lg bg-white text-center shadow hover:shadow-lg cursor-pointer"
						onClick={() => onOpenTabletView()}
					>
						<div className="flex flex-1 flex-col p-8">
							<div className="mx-auto h-32 w-32 flex-shrink-0 rounded-full flex items-center justify-center">
								<DeviceTabletIcon className="w-16 h-16 text-gray-300" />
							</div>
							<h3 className="mt-6 text-sm font-medium text-gray-900">
								Tablet View
							</h3>
							<dl className="mt-1 flex flex-grow flex-col justify-between">
								<dd className="mt-3">
									<span
										className={classNames(
											'inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ring-1 ring-inset',
											true
												? ' bg-green-50 text-green-700 ring-green-600/20'
												: ' bg-gray-50 text-gray-700 ring-gray-600/20'
										)}
									>
										{'Available'}
									</span>
								</dd>
							</dl>
						</div>
					</li>
				</ul>
			</div>
		</>
	);
};

export default Integrations;
